import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { XMarkIcon } from "@heroicons/react/20/solid";
import _ from "lodash";
import { useMutation } from "@apollo/client";
import preAuthGQL from "../../../gql/preAuth";
// import { toast } from "react-toastify";
import toast from "react-hot-toast";

import "../styles/pre-auth.css";
import AppModal from "../../../components/AppModal";
import { Divider } from "@mui/material";
import { styled } from "@mui/material/styles";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { encodeCode } from "./AdvanceCommunicationDetail";
import AppButton from "../../../shared/AppButton";
import CustomFilterInput from "../../../shared/CustomFilterInput";

const AdvanceCommuniModal = ({
  showCommunicationModal,
  setshowCommunicationModal,
  dataArray,
  setdataArray,
  Advance = false,
  item,
  currentItem,
  communicationId,
  communicationRefetch,
  transactionId,
}) => {
  const { t, i18n } = useTranslation();
  //   const [file, setFile] = useState(null)
  const [image, setFile] = useState(null);
  const [fileType, setFileType] = useState(null);
  const [commentArray, setcommentArray] = useState([]);
  const [selectEmpty, setselectEmpty] = useState(false);
  const [selectedItem, setselectedItem] = useState(null);
  const [addCommunication, { data, loading, error }] = useMutation(
    preAuthGQL.ADD_COMMUNICATION,
    {
      update(proxy, result) {
        onSuccessfulRequestResponse(result.data);
      },
      onError(error) {
        onResponseError(error.graphQLErrors[0]);
      },
    },
  );
  console.log(item, "itmes here");
  console.log(currentItem);

  const onSuccessfulRequestResponse = (data) => {
    if (data?.communicationRequest?.nphies_err) {
      toast.error(data?.communicationRequest?.message);

      data?.communicationRequest?.nphies_err &&
        data?.communicationRequest?.nphies_err.length > 0 &&
        data?.communicationRequest?.nphies_err?.map((err) =>
          toast.error(`${err?.code} - ${err?.display}`),
        );
    } else {
      toast.success(
        data?.communicationRequest?.message || t("Successfully Added!"),
      );
      setshowCommunicationModal(false);
    }

    communicationRefetch({
      input: {
        transaction_id: transactionId,
        // request_name: "preAuth",
        request_name: "advanced-auth",
      },
    });
    setcommentArray([]);
  };

  const onResponseError = (error) => {
    toast.error(`${error?.message}`);
  };

  // let temp = [...dataArray];
  // temp.push(commentArray);
  // setdataArray(temp);

  const [obj, setobj] = useState({
    payload_attachment: null,
    payload_comment: null,
    item_sequence: null,
  });
  const getCurrentDate = () => {
    const currentDate = new Date();

    const day = String(currentDate.getDate()).padStart(2, "0");
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const year = String(currentDate.getFullYear());

    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  };

  const removeItem = (data, index) => {
    let tempArray = [...commentArray];
    tempArray.splice(index, 1);
    setcommentArray(tempArray);
  };

  const addDataTwo = (e) => {
    e.preventDefault();
    if (obj.payload_attachment === "" && obj.payload_comment === "") {
      setselectEmpty(true);

      return;
    }

    let tempArr = [...commentArray];
    tempArr.push({ ...obj });
    setcommentArray(tempArr);

    setobj({
      payload_attachment: null,
      payload_comment: null,
      item_sequence: null,
    });
    setFile(null);
  };

  const handleChange = (e) => {
    setobj((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const addToCommunication = () => {
    // changeToBase64Data();
    try {
      if (communicationId) {
        addCommunication({
          variables: {
            input: {
              transaction_id: currentItem?.transaction_id,
              // type: "solicited",
              type: "solicit",
              // request_name: "preAuth",
              request_name: "advanced-auth",
              communication_id: communicationId,
              payload: [...commentArray],
            },
          },
        });
      } else {
        addCommunication({
          variables: {
            input: {
              transaction_id: currentItem?.transaction_id,
              type: "unsolicit",
              // type: "unsolicited",
              // request_name: "preAuth",
              request_name: "advanced-auth",
              payload: [...commentArray],
            },
          },
        });
      }

      setcommentArray([]);
      formik.resetForm();
    } catch (error) {
      console.log("The mutation error is ", error.message);
    }
  };

  const formik = useFormik({
    initialValues: {
      payload_attachment: null,
      payload_comment: null,
      item_sequence: null,
    },
    validationSchema: Yup.object().shape({
      payload_attachment: Yup.object({
        payload_attachment_content_type: Yup.mixed()
          .nullable()
          .label(t("File Type"))
          .test(
            "fileFormat",
            t("Invalid file format. Please upload a JPG, JPEG, or PDF file."),
            (value) => {
              if (value) {
                return (
                  value === "image/jpeg" ||
                  value === "image/jpg" ||
                  value === "application/pdf"
                );
              }
              return true;
            },
          ),
        payload_attachment_data: Yup.mixed().nullable().label(t("File")),
        payload_attachment_title: Yup.string().nullable(),
        payload_attachment_creation_date: Yup.string().nullable(),
      }).nullable(),
      payload_comment: Yup.string()
        .nullable()
        .test(
          "commentOrAttachment",
          t("Either attachment or comment is required"),
          function (value) {
            const { payload_attachment } = this.parent;
            if (
              !value &&
              (!payload_attachment?.payload_attachment_content_type ||
                !payload_attachment?.payload_attachment_data)
            ) {
              return this.createError({
                path: "payload_comment",
                message: t("Either attachment or comment is required"),
              });
            }
            return true;
          },
        ),
      item_sequence: Yup.number().nullable(),
    }),

    onSubmit: async (values) => {
      let tempArr = [...commentArray];
      tempArr.push({ ...values });
      setcommentArray(tempArr);
      formik.resetForm();
    },
  });

  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        setFile(URL.createObjectURL(event.target.files[0]));
        setFileType(file.type);

        formik?.setValues((prev) => ({
          ...prev,
          payload_attachment: {
            payload_attachment_content_type: file.type,
            payload_attachment_data: reader.result?.split(",")[1],
            payload_attachment_title: file.name,
            payload_attachment_creation_date: getCurrentDate(),
          },
          // [e.target.name]:e.target.valueobj
        }));
      };
    }
  };

  useEffect(() => {
    if (formik?.values?.payload_attachment) {
      formik?.setFieldValue("payload_comment", null);
    }
  }, [formik?.values?.payload_attachment]);

  useEffect(() => {
    if (formik?.values?.item_sequence) {
      formik?.setFieldValue(
        "item_sequence",
        parseInt(formik?.values?.item_sequence),
      );
    }
  }, [formik?.values?.item_sequence]);

  return (
    <div
      className={`${showCommunicationModal ? "open" : ""} modal`}
      id="search-filter"
    >
      <div class="modal-content">
        <div className="flex items-center justify-between border-b pb-3 mb-2">
          <div className="text-sm font-bold text-gray-700 uppercase">
            {communicationId
              ? t("Reply to Communication")
              : t("Add Communication")}
          </div>
          <div
            onClick={() => setshowCommunicationModal(false)}
            className="h-6 w-6 bg-[#0070C2] rounded-full flex items-center justify-center cursor-pointer hover:bg-blue-800 transition-colors shadow-sm"
          >
            <XMarkIcon className="h-4 w-4 text-white" />
          </div>
        </div>
        <div class="">
          <div className="flex flex-col items-center">
            <AppButton
              component="label"
              startIcon={<CloudUploadIcon />}
              className="!w-full !py-2"
            >
              <span className="truncate max-w-[250px]">
                {formik.values.payload_attachment?.payload_attachment_title ||
                  t("Upload Attachment")}
              </span>
              <input
                type="file"
                hidden
                onChange={onImageChange}
                accept="image/*,application/pdf"
              />
            </AppButton>
            {formik.errors.payload_attachment
              ?.payload_attachment_content_type && (
              <p className="text-[10px] text-red-500 mt-1">
                {
                  formik.errors.payload_attachment
                    .payload_attachment_content_type
                }
              </p>
            )}
          </div>

          {!formik?.values?.payload_attachment && (
            <>
              <Divider>
                <span className="text-[10px] text-gray-400 uppercase">
                  {t("or")}
                </span>
              </Divider>
              <CustomFilterInput
                label={t("Comment")}
                placeholder={t("Enter your comment here")}
                name="payload_comment"
                value={formik.values.payload_comment}
                onChange={formik.handleChange}
                error={formik.errors.payload_comment}
                touched={formik.touched.payload_comment}
              />
            </>
          )}

          <CustomFilterInput
            label={t("Item Sequence")}
            isSelect
            name="item_sequence"
            value={formik.values.item_sequence}
            onChange={(e) =>
              formik.setFieldValue("item_sequence", e.target.value)
            }
            options={item?.map((itm) => ({
              id: itm?.sequence_no,
              name: itm.standard_description,
            }))}
            placeholder={t("Select Item Sequence")}
            error={formik.errors.item_sequence}
            touched={formik.touched.item_sequence}
          />

          <AppButton
            label={t("Add to List")}
            fullWidth
            onClick={formik.handleSubmit}
            bgColor="#10b981"
          />
          {/* <div className="mt-11">
            {commentArray
              ? commentArray.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className="flex justify-between bg-cyan-50 my-2 rounded-md"
                    >
                      <div
                        className="flex flex-col gap-2   py-2 px-2 flex-1
                  rounded-md
                  "
                      >
                        <div>
                          {item?.payload_attachment?.payload_attachment_data ? (
                            <div>
                              {item?.payload_attachment
                                ?.payload_attachment_content_type ===
                              "application/pdf" ? (
                                item?.payload_attachment
                                  ?.payload_attachment_title
                              ) : (
                                <img
                                  src={
                                    "data:image/jpeg;base64," +
                                    item.payload_attachment
                                      .payload_attachment_data
                                  }
                                  alt={`${item?.payload_attachment?.payload_attachment_title}`}
                                  className="w-12 h-12 rounded-full"
                                />
                              )}
                            </div>
                          ) : (
                            ""
                          )}
                        </div>

                        {!item?.payload_attachment?.payload_attachment_data && (
                          <div className="flex items-center gap-2">
                            <h3 className="font-semibold">{t("Comment")}:</h3>

                            <span className="text-sm text-gray-500">
                              {item?.payload_comment
                                ? item?.payload_comment
                                : "-"}
                            </span>
                          </div>
                        )}

                        <div className="flex items-center gap-4">
                          <span>
                            <span className="font-semibold">{t("Seq")}:</span>{" "}
                            {item?.item_sequence}
                          </span>
                        </div>
                      </div>
                      <div className="p-2">
                        <XMarkIcon
                          className="h-5 w-5 text-gray-900 hover:cursor-pointer "
                          aria-hidden="true"
                          onClick={() => removeItem(item, index)}
                        />
                      </div>
                    </div>
                  );
                })
              : ""}
          </div> */}
          <div className="max-height-[200px] overflow-y-auto pt-2">
            {commentArray.map((msg, index) => (
              <div
                key={index}
                className="flex justify-between items-center bg-blue-50 p-2 rounded-lg mb-2 border border-blue-100 shadow-sm"
              >
                <div className="flex flex-col gap-1">
                  <div className="text-[10px] font-bold text-blue-800">
                    {t("Seq")}: {msg.item_sequence}
                  </div>
                  <div className="text-[11px] text-gray-600">
                    {msg.payload_attachment ? (
                      <span className="flex items-center gap-1 text-green-600 font-semibold italic">
                        📎 {msg.payload_attachment.payload_attachment_title}
                      </span>
                    ) : (
                      msg.payload_comment
                    )}
                  </div>
                </div>
                <XMarkIcon
                  className="h-4 w-4 text-red-400 cursor-pointer hover:text-red-600"
                  onClick={() => removeItem(index)}
                />
              </div>
            ))}
          </div>
          <div className="flex gap-2 pt-2 border-t">
            <AppButton
              label={
                communicationId ? t("Send Reply") : t("Send Communication")
              }
              fullWidth
              disabled={commentArray.length === 0}
              onClick={addToCommunication}
              isLoading={loading}
            />
            <AppButton
              label={t("Cancel")}
              variant="outlined"
              fullWidth
              bgColor="transparent"
              className="!text-gray-500 !border-gray-300"
              onClick={() => setshowCommunicationModal(false)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdvanceCommuniModal;
